import { type QueryHookOptions, useQuery } from "@apollo/client";
import { OrganizationUserQuery } from "../graphql/queries";
import type {
  OrganizationUserQueryType,
  OrganizationUserQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useOrganizationUserQuery = (
  options?: QueryHookOptions<
    OrganizationUserQueryType,
    OrganizationUserQueryVariablesType
  >
) => {
  return useQuery<
    OrganizationUserQueryType,
    OrganizationUserQueryVariablesType
  >(OrganizationUserQuery, options);
};
